import React from 'react';
import { iconForField } from '../custom/icon-library';

const CustomInputWithIcon = ({ icon, children, title, required, extraCss }) => {
  return (
    <div className={`form-group ${extraCss ? extraCss : ''}`}>
      <div className="input-group">
        <div className="input-group-prepend" title={title}>
          <span className="input-group-text">
            <i className={`wb ${iconForField(icon)}`}></i>
            {required && <span className="required">*</span>}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
};

export default CustomInputWithIcon;
